import { getCoreUtils, nz } from "../../../Admin/kReusableCoreTS/kCoreHandler";
import { kPhoneNumberCore } from "../../../Admin/kReusableCoreTS/kPhoneNumberCore";

// AppPhoneWords - A CONTACT'S NUMBER AS IT IS READ ("+46 705 550 142"), for the chat header's Phone field.
//
// The shared `kPhoneNumberCore` normalises and validates E.164; it does not SPACE a number for reading, so this does
// (kPhoneNumberCore has no display form - checked 2026-10-13). A second consumer needs nothing changed: E.164 in,
// words out, no project type in the signature.
// ⛔ ONLY A REAL NUMBER IS SHOWN: anything that is not E.164 (a `lid:` person key, an unknown contact, "") answers "" and
// the field is left out - a privacy alias must never be dressed up as a phone number.
// ⚠ THE SPACING IS A READING AID, NOT A NATIONAL FORMAT: the country calling code is split off by ITU-T E.164's own
// table of 1- and 2-digit codes (everything else is 3 digits), and the rest is grouped in threes (a last lone digit joins
// the group before it). No country's own grouping is claimed.

export class AppPhoneWords {
    /** ITU-T E.164 country calling codes of ONE digit (the NANP zone and Russia/Kazakhstan). */
    public static readonly One: string[] = ["1", "7"];
    /** ... and of TWO digits. Every other code is three digits long. */
    public static readonly Two: string[] = ["20", "27", "30", "31", "32", "33", "34", "36", "39", "40", "41", "43", "44", "45", "46",
        "47", "48", "49", "51", "52", "53", "54", "55", "56", "57", "58", "60", "61", "62", "63", "64", "65", "66", "81", "82", "84",
        "86", "90", "91", "92", "93", "94", "95", "98"];

    /** How many digits of `Digits` (no plus) are the country calling code. */
    public static CodeLength = (Digits: string): number => {
        if (getCoreUtils().KErrorMode === true) { return 0; }
        try {
            if (AppPhoneWords.One.indexOf(Digits.substring(0, 1)) >= 0) { return 1; }
            if (AppPhoneWords.Two.indexOf(Digits.substring(0, 2)) >= 0) { return 2; }
            return 3;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppPhoneWords.CodeLength");
            return 0;
        }
    };

    /** Digits in groups of three; a last group of ONE digit joins the group before it ("7055501" -> "705 5501"). */
    public static Threes = (Digits: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            const Out: string[] = [];
            for (let At: number = 0; At < Digits.length; At = At + 3) { Out.push(Digits.substring(At, At + 3)); }
            if (Out.length > 1 && Out[Out.length - 1].length === 1) {
                const Last: string = Out.pop() as string;
                Out[Out.length - 1] = Out[Out.length - 1] + Last;
            }
            return Out.join(" ");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppPhoneWords.Threes");
            return "";
        }
    };

    /** "+46705550142" -> "+46 705 550 142"; "" for anything that is not an E.164 number. */
    public static Format = (PersonKey: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            const Key: string = nz(PersonKey).trim();
            if (kPhoneNumberCore.IsE164(Key) !== true) { return ""; }
            const Digits: string = Key.substring(1);
            const Code: number = AppPhoneWords.CodeLength(Digits);
            if (Code <= 0 || Digits.length <= Code) { return ""; }
            return "+" + Digits.substring(0, Code) + " " + AppPhoneWords.Threes(Digits.substring(Code));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppPhoneWords.Format");
            return "";
        }
    };
}
